<template>
  <WrapperFormElements
    :label
    :required
    :hint
    :help
    :alertLabel
    :alertType
    :wrapLabel
    :nbMaxLines
  >
    <BasicToggleSwitch
      v-model="modelValue"
      :items
      :disabled
      :readonly
      :size
      :key-id="keyId"
      :key-label="keyLabel"
    />
  </WrapperFormElements>
</template>

<script setup lang="ts" generic="TToggleItem = ToggleItem, TToggleKey extends ToggleId = ToggleId">
  import type { ToggleId, ToggleItem, WrapperToggleSwitchProps } from '@designSystem/components'

  withDefaults(defineProps<WrapperToggleSwitchProps<TToggleItem>>(), {
    wrapLabel: true,
  })

  const modelValue = defineModel<TToggleKey>()
</script>
